<template>
  <div class="flex w-full justify-center space-x-10 mb-8">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      @click="$emit('tab-change', tab.id)"
      :class="[
        'w-full py-2 px-6 text-sm font-semibold rounded-xl border-2 border-black transition-colors',
        'shadow-[6px_4px_0_0_rgba(0,0,0,1)] cursor-pointer',
        activeTab === tab.id
          ? 'bg-blue-600 text-white cursor-pointer'
          : 'bg-gray-100 text-gray-700',
      ]"
    >
      {{ tab.name }}
    </button>
  </div>
</template>

<script setup lang="ts">
interface Tab {
  id: string;
  name: string;
}

interface Props {
  activeTab: string;
  tabs: Tab[];
}

defineProps<Props>();

defineEmits<{
  "tab-change": [tabId: string];
}>();
</script>
